import { CONTINUE_CREATION } from '../reducers/constants/continueCreation';

export const continueCreation = page => ({
  type: CONTINUE_CREATION,
  page
});
